import styled from "styled-components";

export const CheckoutLPContainer = styled.div`
  padding-block: 32px;
  padding-inline: 400px;
  flex-wrap: wrap;
  margin: 0px;
  height: 100vh;

  background: linear-gradient(
    to top,
    ${({ bgColor }) => {
      // recebe bgColor em hexadecimal e converte pra rgb
      const r = parseInt(bgColor.slice(1, 3), 16);
      const g = parseInt(bgColor.slice(3, 5), 16);
      const b = parseInt(bgColor.slice(5, 7), 16);

      // usa o rgb na função rgba pra colocar opacidade
      return `rgba(${r}, ${g}, ${b}, 0.6)`;
    }},
    ${({ bgColor }) => bgColor}
  );

  @media screen and (min-width: 800px) and (max-width: 1024px) {
    width: 100%;
    padding-inline: 5%;
    flex-direction: column;
  }

  @media screen and (min-width: 1025px) {
    width: 100%;
    padding-inline: 15%;
    flex-direction: column;
  }

  @media screen and (max-width: 799px) {
    padding-inline: 1px;
    flex-direction: column;
    width: 100%;
  }
`;

export const PixPayment = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-direction: row;

  @media screen and (max-width: 799px) {
    display: block;
    width: 100%;
    padding-inline: 8px;
  }
`;

export const InfoPixContainer = styled.div`
  padding: 24px 32px;
  width: 100%;
  background: #ffffff;
  box-shadow: 6.04275px 26.1419px 34.875px rgba(0, 0, 0, 0.04725),
    2.38726px 10.3277px 13px rgba(0, 0, 0, 0.035), 0.522213px 2.25918px 4.625px rgba(0, 0, 0, 0.02275);
  border-radius: 12px;

  p {
    align-items: center;
    font-size: 18px;
  }

  .info {
    padding-inline: 5%;
  }

  @media screen and (max-width: 799px) {
    width: 100%;
    padding-inline: 12px;
  }

  h2 {
    color: #1f2937;
  }
  @media screen and (min-width: 800px) {
    width: 68%;
    flex-direction: row;
  }
`;

export const HeaderInfoContents = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
`;

export const PixInstruction = styled.div`
  .pix-alert {
    display: flex;
  }

  .pix-intructions {
    padding-block: 3%;
    padding-inline: 10%;
  }

  @media screen and (max-width: 799px) {
    width: 90%;
    margin-inline: 5%;

    .intructions {
      padding-inline: 5%;
    }
  }
`;

export const AlertTriangle = styled.img`
  height: 20px;
  padding-right: 7px;
`;

export const LoaderStyle = styled.div`
  height: 140px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const PixBox = styled.div`
  transition-timing-function: ease-in-out;
  transition-duration: 0.1s;
  border: 1px solid #989898;
  margin-inline: 30%;

  padding-block: 2%;
  padding-inline: 2%;

  background: #ffffff;
  border: 0.5px solid #000000;
  border-radius: 12px;

  p {
    font-size: 12px;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
    background: #0086bf;
    padding: 10px 24px;
    border-radius: 118px;
    margin-inline: 4%;
    margin-bottom: 3%;
    padding-inline: 6%;
  }

  .captcha {
    border: 1px solid #989898;
    margin-inline: 4%;
    padding: 5%;
    text-align: center;
    height: fit-content;

    svg {
      height: 100%;
      width: 100%;
    }
  }

  @media screen and (min-width: 375px) and (max-width: 667px) {
    margin-inline: 12%;
  }

  @media screen and (min-width: 668px) and (max-width: 1023px) {
    margin-inline: 25%;
  }

  @media screen and (min-width: 1024px) {
    margin-inline: 30%;
  }
`;

export const PixCode = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  margin-top: 2%;
  padding-block: 3%;
  padding-top: 20px;
  padding-inline: 5%;
  word-break: break-all;

  h4 {
    width: 100%;
    margin-bottom: 6px;
  }

  button {
    justify-content: center;
  }
`;

export const CopyButton = styled.button`
  display: inline-flex;
  align-items: center;
  outline: 0;
  cursor: pointer;
  border: none;
  padding: 0 56px;
  height: 45px;
  line-height: 45px;
  border-radius: 7px;
  font-weight: 400;
  font-size: 16px;
  background: #0086bf;
  color: white;
  box-shadow: 0 4px 14px 0 rgb(0 0 0 / 10%);
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
  :hover {
    background: rgba(0, 118, 255, 0.9);
    box-shadow: 0 6px 20px rgb(93 93 93 / 23%);
  }
`;
export const ErrorMessage = styled.div`
  text-align: center;
  padding-block: 5%;
  padding-inline: 5%;

  span {
    color: white;
    font-weight: 700;
    background-color: red;
    border-radius: 0.5vh;
    padding: 1%;
  }
`;

export const ProductInfo = styled.div`
  border: 1px solid #989898;
  width: 25%;
  border-radius: 8px;
  padding: 12px;
  background-color: #fff;

  h2 {
    font-size: 30px;
  }

  @media screen and (max-width: 799px) {
    width: 90%;
  }

  @media screen and (min-width: 800px) and (max-width: 1023px) {
    width: 90%;
  }
`;

export const LogoImg = styled.img`
  width: 96px;
  height: 41px;
`;

export const CheckoutLPBrasil = styled.article`
  width: 100%;
  justify-content: center;
  display: flex;
  height: 42px;
  background: white;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

  p {
    margin: 12px 0;
  }
`;

export const CheckoutLPFlag = styled.img`
  height: 20px;
  padding-right: 10px;
  margin: 12px 0;
`;

export const PurchaseSummary = styled.div`
  position: sticky;
  top: 10px;
  padding: 24px 24px;
  width: 28%;
  background: #ffffff;
  box-shadow: 6.04275px 26.1419px 34.875px rgba(0, 0, 0, 0.04725),
    2.38726px 10.3277px 13px rgba(0, 0, 0, 0.035), 0.522213px 2.25918px 4.625px rgba(0, 0, 0, 0.02275);
  border-radius: 12px;
  height: fit-content;

  @media screen and (min-width: 800px) {
    width: 28%;
  }

  @media screen and (max-width: 799px) {
    width: 100%;
    margin-top: 10px;
    h2 {
      font-size: 20px;
    }
  }

  h2 {
    font-family: "Source Sans Pro";
    font-style: normal;
    font-weight: 600;
  }

  h4 {
    font-family: "Source Sans Pro";
    font-style: normal;
    font-weight: 400;
  }
`;

export const TitleProducts = styled.h3`
  margin-bottom: 22px;
`;

export const BoxProductValues = styled.div`
  border-radius: 12px;
  border: 1px solid #989898;
  padding: 16px 15px;
  margin-bottom: 12px; // provavelmente mudar aqui
  display: flex;
  width: 100%;

  .productsAndPrices {
    width: 90%;
    line-height: 28px;
  }

  .alert {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media screen and (max-width: 799px) {
    padding: 16px;

    h2 {
      font-size: 20px;
    }
  }

  @media screen and (min-width: 800px) and (max-width: 1023px) {
    padding: 8px;

    h2 {
      font-size: 15px;
    }
  }

  @media screen and (min-width: 1024px) and (max-width: 1120px) {
    padding: 10px;

    h2 {
      font-size: 16px;
    }
  }

  @media screen and (min-width: 1121px) {
    padding: 13px;

    h2 {
      font-size: 18px;
    }
  }
`;

export const PurchaseDetails = styled.div`
  margin-top: 30px;
  margin-bottom: 36px;
  .textLine {
    margin-bottom: 12px;
    .textLeft {
      color: #545454;
      font-size: 20px;
      font-weight: 500;
    }
    .textRight {
      font-size: 20px;
      color: #000;
      font-weight: bold;
    }
  }

  .totalTextLine {
    margin-top: 22px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
    .textLeft {
      color: #545454;
      font-size: 20px;
    }
    .textRight {
      font-size: 20px;
      color: #000;
      font-weight: bold;
    }
  }
`;
export const LineDivider = styled.hr`
  background-color: #d9d9d9;
  height: 1px;
  border: none;
`;

export const DivLogoImg = styled.div`
  display: flex;
  width: 100%;
  margin-top: 15px;
  justify-content: center;
  align-items: center;
  padding-inline: 12px;
  padding-top: 12px;
`;

export const LogoMrImg = styled.img`
  width: 184px;
  height: 70px;
`;
